// Build lookup map from categories array
function buildTypeLookup(categories) {
  const lookup = {}
  for (const cat of categories) {
    for (const code of cat.codes) {
      lookup[code.toUpperCase()] = cat
    }
  }
  return lookup
}

// Get type category - uses station categories only, no defaults
export function getTypeCategory(typeCode, stationCategories = null, defaultColor = '#999999') {
  // If no type code, return default
  if (!typeCode) {
    return { label: 'MUSIC', color: defaultColor }
  }
  
  // If station has categories, look up the type code
  if (stationCategories && stationCategories.length > 0) {
    const lookup = buildTypeLookup(stationCategories)
    const cat = lookup[typeCode.toUpperCase()]
    if (cat) return cat
  }
  
  // Not found or no categories - return the type code itself as label
  return { label: typeCode.toUpperCase(), color: defaultColor }
}

export function fmtTime(ts) {
  return new Date(ts).toTimeString().split(' ')[0]
}

export function fmtDate(ts) {
  const d = new Date(ts)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function formatDatetimeLocal(ts) {
  const d = new Date(ts)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}`
}

export function truncateText(ctx, text, maxW) {
  if (!text) return ''
  if (ctx.measureText(text).width <= maxW) return text
  let t = text
  while (t.length > 0 && ctx.measureText(t + '…').width > maxW) t = t.slice(0, -1)
  return t + '…'
}

export function escapeHtml(s) {
  const d = document.createElement('div')
  d.textContent = s || ''
  return d.innerHTML
}

export function formatBytes(bytes) {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}
